var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnpremises(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 2.5H4.625M3.25 4.5H4.625M3.25 6.5H4.625M6.375 2.5H7.75M6.375 4.5H7.75M6.375 6.5H7.75M9.5 9.5V2.1C9.5 1.53995 9.5 1.25992 9.391 1.04601C9.29515 0.857845 9.14215 0.704865 8.954 0.608995C8.7401 0.5 8.46005 0.5 7.9 0.5H3.1C2.53994 0.5 2.25992 0.5 2.04601 0.608995C1.85785 0.704865 1.70486 0.857845 1.60899 1.04601C1.5 1.25992 1.5 1.53995 1.5 2.1V9.5M10.5 9.5H0.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnpremises);
export default __webpack_public_path__ + "static/media/onpremises.d0a91748ee176217446b93043024dbee.svg";
export { ForwardRef as ReactComponent };